import { darken, gridClasses, lighten, useTheme } from '@mui/material';
import { DataGridProps } from '@mui/x-data-grid';
import { getPermanentMacStyleScrollbarStyles } from 'components/theme/theme';
export const useDataGridStyle = (): DataGridProps['sx'] => {
  const theme = useTheme();
  const sx: DataGridProps['sx'] = {
    '& .MuiToolbar-root': {
      paddingLeft: '10px',
      paddingRight: '10px',
    },
    '& .MuiDataGrid-withBorderColor': {
      borderColor: theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
      borderRightStyle: 'solid',
      borderRightWidth: '1px',
    },

    '& .MuiDataGrid-columnHeader': {
      backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900],

      '& .MuiDataGrid-columnHeaderTitleContainerContent': {
        '&, &>.MuiDataGrid-columnHeaderTitle, & .MuiTypography-root': {
          fontWeight: 'bold',
          textOverflow: 'ellipsis',
          overflow: 'clip',
          display: 'inline-block',
        },
      },
    },
    '& .MuiDataGrid-columnHeaderTitleContainerContent': {
      width: '100%',
    },
    '& .cell-value-changed': {
      backgroundColor: 'rgba(0, 0, 255, 0.1)',
    },
    '& .cell-error': {
      backgroundColor: 'rgba(255, 0, 0, 0.5)',
    },
    '& .MuiTablePagination-root': {
      display: 'flex',
      justifyContent: 'flex-end',
      // Don't show scrollbar for pagination controls
      overflow: 'hidden',
    },
    '& .MuiDataGrid-overlayWrapper': {
      height: '100%',
      '& .MuiDataGrid-overlayWrapperInner': {
        height: '100%',
      },
    },
    ...getPermanentMacStyleScrollbarStyles(theme, true),
  };
  return sx;
};

export const useSettingsDataGridStyles = (): DataGridProps['sx'] => {
  const baseSx = useDataGridStyle();
  const theme = useTheme();

  return {
    ...baseSx,
    width: '100%',
    minHeight: '100%',
    // Mark required cells or duplicate cells with a red background
    '& .MuiDataGrid-row--editing .MuiDataGrid-cell.missing-required-cell, & .MuiDataGrid-row--editing .MuiDataGrid-cell.duplicate-cell, & .MuiDataGrid-row--editing .MuiDataGrid-cell.error-cell':
      {
        backgroundColor: 'rgba(255, 0, 0, 0.1)',
      },

    // Mark draft cells with a blue background
    '& .MuiDataGrid-row--editing .MuiDataGrid-cell.draft-cell': {
      backgroundColor: 'rgba(0, 200, 255, 0.1)',
    },

    // Mark deleted rows with a darker red background
    '& .deleted-row': {
      backgroundColor: theme.palette.mode === 'light' ? theme.palette.error.light : theme.palette.error.dark,
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor:
          theme.palette.mode == 'light'
            ? darken(theme.palette.error.light, 0.2)
            : lighten(theme.palette.error.dark, 0.2),
      },
    },
  };
};

export const bulkEditGridStyles: DataGridProps['sx'] = {
  '& .MuiDataGrid-iconSeparator': {
    transform: 'scaleY(3)',
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    alignItems: 'flex-start',
    marginY: 'auto',
    '& .MuiDataGrid-iconButtonContainer': {
      marginY: 0.5,
    },

    [`& .${gridClasses.container}> .${gridClasses.item}`]: {
      mt: 1,
      overflow: 'auto',
      zIndex: 1,
    },
  },
  '& .MuiDataGrid-menuIcon': {
    alignItems: 'flex-start',
    marginY: 0.5,
  },
};
